import { DashboardFormWrapper } from '../../dashboard';
import { CompanyPage, CompanyHeader, CompanyForm } from '../CompanyFormComponents';
import { RoleGuard } from '../../../routes';
import { useStoreUser } from '../../../context';
import { Roles } from '../../../types';

export const ClientsAdd = () => {
  const { user } = useStoreUser();

  return (
    <RoleGuard
      roles={[
        'SUPER_ADMIN',
        'YARD_COMPANY_ADMIN',
        'YARD_MANAGER',
        ...((user.yardEmployee?.canCreateClient ? ['YARD_DISPATCHER'] : []) as Roles[]),
      ]}
    >
      <CompanyPage>
        <CompanyHeader belongsTo={'CLIENT'} />
        <DashboardFormWrapper flow={'row'}>
          <CompanyForm belongsTo={'CLIENT'} />
          <CompanyHeader belongsTo={'CLIENT'} showOnlySubmit />
        </DashboardFormWrapper>
      </CompanyPage>
    </RoleGuard>
  );
};
